import React from 'react';
import useTokenResolver from './hooks/useTokenResolver';
import { SessionProvider } from './contexts/SessionContext';
import SessionGuard from './components/SessionGuard';
import PortalPage from './components/PortalPage';
import TokenLoadingScreen from './components/TokenLoadingScreen';
import TokenErrorScreen from './components/TokenErrorScreen';

export default function App() {
  const {
    status,
    token,
    loanApplicationId,
    clientData,
    error,
    isLoading,
    isReady,
    isError,
    retry,
  } = useTokenResolver();

  if (isLoading) {
    return <TokenLoadingScreen status={status} />;
  }

  if (isError) {
    return <TokenErrorScreen error={error} onRetry={retry} />;
  }

  if (isReady) {
    return (
      <SessionProvider linkToken={token} loanApplicationId={loanApplicationId}>
        <PortalPage
          token={token}
          loanApplicationId={loanApplicationId}
          clientData={clientData}
        />
      </SessionProvider>
    );
  }

  // Fallback (should not reach here)
  return <TokenLoadingScreen status="extracting" />;
}
